<template>
  <div>
    <google-maps-search-bar
      ref="search"
      @onSearch="onSearch"
      :searchQuery="markerModel.fullAddress"
      :map="$refs.map"
    />
    <google-map
      ref="map"
      :style="{ width: '100%', height: '400px' }"
      :center="{ lat: markerModel.latitude, lng: markerModel.longitude }"
      :zoom="13"
      @mapRightClick="mapRightClick"
    >
      <google-map-marker
        v-if="markerModel"
        :position="{ lat: markerModel.latitude, lng: markerModel.longitude }"
        primary
      />
    </google-map>
  </div>
</template>

<script>
import WaypointResequenceMixin from "@/mixins/tripPlan/WaypointResequenceMixin.js";

export default {
  name: "GoogleMapMarkerCrud",
  components: {
    GoogleMap: () => import("@/components_rms/base/googlemaps/GoogleMap.vue"),
    GoogleMapMarker: () =>
      import("@/components_rms/base/googlemaps/GoogleMapMarker.vue"),
    GoogleMapsSearchBar: () =>
      import("@/components_rms/base/googlemaps/GoogleMapSearchbar.vue")
  },
  mixins: [WaypointResequenceMixin],
  props: {
    model: Object,
    id: String
  },
  data() {
    return {};
  },
  computed: {
    markerModel: {
      get: function() {
        return this.model;
      },
      set: function(newValue) {
        this.$emit("update:model", newValue);
      }
    }
  },
  methods: {
    mapRightClick(e) {
      this.markerModel = {
        latitude: e.latLng.lat(),
        longitude: e.latLng.lng(),
        fullAddress: this.model.fullAddress
      };
    },
    onSearch(searchResult) {
      this.markerModel = searchResult;
    }
  },
  watch: {
    model() {
      if (!this.model) return;
      this.$refs.map.fitBounds([[this.model.latitude, this.model.longitude]]);
    }
  }
};
</script>

<style scoped>
.imageMap {
  width: 25% !important;
}
</style>
